// src/layout/Sidebar.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../routesConfig";

export default function Sidebar() {
  return (
    <div className="flex h-screen flex-col">
{/* Logo / Title */}
<div className="p-4 border-b">
  <div className="flex flex-col items-center gap-2">
    <img 
      src="/logo.svg"  // ou logo.png
      alt="Hippolyte"
      className="h-16 w-auto"  // Logo plus grand
    />
    <div className="text-sm font-medium text-gray-700">Console</div>
  </div>
</div>

      {/* Nav items */}
      <nav className="flex-1 overflow-y-auto p-2">
        <ul className="space-y-1">
          {ROUTES.map((r) => (
            <li key={r.path}>
              <NavLink
                to={r.path}
                className={({ isActive }) =>
                  [
                    "flex items-center gap-3 rounded-lg px-3 py-2 text-sm",
                    isActive ? "bg-black text-white" : "text-gray-700 hover:bg-gray-100",
                  ].join(" ")
                }
              >
                <r.icon className="h-4 w-4" />
                <span>{r.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-3 border-t text-xs text-gray-500">
        © {new Date().getFullYear()} Hippolyte
      </div>
    </div>
  );
}
